import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'
class ClusterDBScan extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.clusterdbscan',
        group: 'Spatial Analysis',
        title: 'ST Cluster DBSCAN',
        description: `
      This component performs a DBSCAN clustering.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'radius',
          type: WorkflowComponentParamType.Number,
          title: 'Search radius (m)',
          min: 0
        },
        {
          name: 'min_geog',
          type: WorkflowComponentParamType.Number,
          title: 'Minimum number of geographies',
          min: 0
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type !== Provider.BigQuery) {
      return null
    }
    return dedent`SELECT *,
              ST_CLUSTERDBSCAN(
                ${params.geo},
                ${params.radius},
                ${params.min_geog}
              )
              OVER () AS cluster
            FROM ${connection.quoteName(params.source as string)}`
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `cluster`,
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery]
  }
}

export { ClusterDBScan }
